module.exports = __webpack_public_path__ + "static/media/system-browser.d7ebfe86.svg";